import React, {useEffect, useState} from 'react';
import {getFilterDetailsList} from "../../../microComponents/tablePages/getFilterDetailsList";
import FilterSelectOption from "../../../microComponents/tablePages/filter/FilterSelectOption";

const FilterDetails = () => {
    const [filterDetailsList, setFilterDetailsList] = useState({});
    const [filterDetailsListLoading, setFilterDetailsListLoading] = useState(false);
    console.log(4444)


    useEffect(() => {
        getFilterDetailsList(setFilterDetailsList, setFilterDetailsListLoading)


    }, [])
    return (
        <>


            <FilterSelectOption data={{
                filterName: 'type',
                loading: filterDetailsListLoading, placeholder: 'نوع', options: filterDetailsList.type
            }}/>


            <FilterSelectOption data={{
                filterName: 'brand',
                loading: filterDetailsListLoading,
                placeholder: 'برند',
                options: filterDetailsList?.brand
            }}/>
        </>
    );
};

export default FilterDetails;